<div class="mt-4">
  <h3 class="text-lg font-medium text-gray-800 mb-3">
    Mis direcciones guardadas
  </h3>

  <!-- Mensaje de error -->
  @if (errorMessage) {
    <div class="p-3 bg-red-100 text-red-700 rounded-md mb-3">
      {{ errorMessage }}
    </div>
  }

  <!-- Skeleton loader durante la carga -->
  @if (isLoading) {
    <div>
      @for (i of [1, 2, 3]; track i) {
        <div class="mb-3">
          <div class="border rounded-lg p-3 bg-white">
            <ngx-skeleton-loader
          [theme]="{
            height: '24px',
            width: '70%',
            'background-color': '#E5E7EB',
            'margin-bottom': '8px'
          }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
          [theme]="{
            height: '16px',
            width: '90%',
            'background-color': '#F3F4F6',
            'margin-bottom': '4px'
          }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
          [theme]="{
            height: '16px',
            width: '40%',
            'background-color': '#F3F4F6'
          }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      }
    </div>
  }

  <!-- Lista de direcciones -->
  @if (!isLoading && addresses.length > 0) {
    <div
      class="space-y-2 sm:space-y-3"
      >
      @for (address of addresses; track address) {
        <div
          class="gap-1 border rounded-lg p-2 sm:p-3 bg-white hover:bg-yellow-50 cursor-pointer transition-colors duration-200 relative flex"
          (click)="selectAddress(address)"
          >
          <div class="w-4/6 sm:w-7/9">
            <p class="font-medium text-gray-800">{{ address.ad_name }}</p>
            <p class="text-gray-600 text-sm h-[20px] sm:h-auto truncate sm:whitespace-normal">{{ address.ad_full_address }}</p>
            @if (address.ad_reference) {
              <p class="text-gray-500 text-xs">
                Referencia: {{ address.ad_reference }}
              </p>
            }
          </div>
          <div class="w-1/6 sm:w-1/9 flex justify-center items-center">
            <!-- Botón de eliminar -->
            <button
              class=" flex justify-center items-center top-1 right-3 text-gray-400 hover:text-red-500 transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
              (click)="onDeleteAddress($event, address.ad_id)"
              title="Eliminar dirección"
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>
            <div class="w-1/6 sm:w-1/9 flex justify-center items-center">
              <!-- BOTON DE EDITAR -->
              <button
                class="flex justify-center items-center bottom-1 right-3 text-gray-400 hover:text-green-700 transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
                (click)="onEditAddress($event,address)"
                title="Editar dirección">
                <svg xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="currentColor">
                  <path
                    d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/>
                  </svg>
                </button>
              </div>
            </div>
          }
        </div>
      }

      <!-- Mensaje cuando no hay direcciones -->
      @if (!isLoading && addresses.length === 0 && !errorMessage ) {
        <div
          class="p-4 bg-gray-50 rounded-md text-center"
          >
          <p class="text-gray-600">No tienes direcciones guardadas</p>
        </div>
      }
    </div>
